/**
 * Modal Module
 * Modal system with GSAP animations
 */

import { fadeInModal, fadeOutModal } from "./animations.js";
import { initIntl } from "./intl-phone.js";

export function initModal() {
  try {
    createModalContainer();
    setupModalEventListeners();
    console.log("✅ Modal system initialized");
  } catch (error) {
    console.error("❌ Error initializing modal:", error);
  }
}

function createModalContainer() {
  if (document.getElementById("modalContainer")) {
    return;
  }

  const modalHTML = `
    <div id="modalContainer" class="modal-overlay" style="display: none;">
      <div class="modal-content">
        <div class="modal-close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div id="modalBody" style="width:100%"></div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML("beforeend", modalHTML);
}

function setupModalEventListeners() {
  document.addEventListener("click", (e) => {
    // Open modal
    const trigger = e.target.closest("[data-modal-name]");
    if (trigger) {
      e.preventDefault();
      openModal(trigger);
      return;
    }

    // Close modal
    if (
      e.target.classList.contains("modal-close") ||
      e.target.closest(".modal-close") ||
      e.target.id === "modalContainer"
    ) {
      closeModal();
    }
  });

  // Close modal with ESC key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeModal();
    }
  });
}

function openModal(trigger) {
  const modalData = trigger.querySelector("[data-modal-data]");
  const modalContainer = document.getElementById("modalContainer");
  const modalBody = document.getElementById("modalBody");

  if (!modalData || !modalContainer || !modalBody) {
    console.warn("Modal elements not found");
    return;
  }

  try {
    const content = modalData.cloneNode(true);
    content.style.display = "block";

    modalBody.innerHTML = "";
    modalBody.appendChild(content);

    // Init intl phone input if exists
    const hasPhoneInput = modalBody.querySelector(".phone-input");
    if (hasPhoneInput) {
      console.log("📞 Phone input detected, initializing before animation...");
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          initIntl(modalBody);
        });
      });
    }

    modalContainer.style.display = "flex";
    fadeInModal(modalContainer, modalContainer.querySelector(".modal-content"));

    console.log("✅ Modal opened");
  } catch (error) {
    console.error("❌ Error opening modal:", error);
  }
}

function closeModal() {
  const modalContainer = document.getElementById("modalContainer");
  const modalBody = document.getElementById("modalBody");

  if (!modalContainer) {
    return;
  }

  try {
    fadeOutModal(modalContainer, () => {
      modalContainer.style.display = "none";
      if (modalBody) {
        modalBody.innerHTML = "";
      }
    });

    console.log("✅ Modal closed");
  } catch (error) {
    console.error("❌ Error closing modal:", error);
  }
}
